import { required, minLength, maxLength } from "react-admin";

export const validateType = [required(), minLength(3), maxLength(40)];
